import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from '@/components/ui/Toast'
import { SignupPage } from './SignupPage'

// Isolated from the app's global queryClient — avoids cache cross-contamination.
const signupQueryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 5 * 60 * 1000 } },
})

/**
 * Standalone React root for the public /signup page.
 * No AuthProvider, no ContextGate, no RouterProvider — runs without Keycloak.
 * SignupPage owns its own full-screen two-column layout.
 */
export function SignupApp() {
  return (
    <QueryClientProvider client={signupQueryClient}>
      <SignupPage />
      <Toaster />
    </QueryClientProvider>
  )
}
